import { axiosInstance } from '~/common/utils/api.util';

import type { PaginatedApiResponse } from '~/common/types/api.type';
import type {
  UsageHistoryItem,
  UsageHistoryListParams,
} from '~/features/usage-history/types/usage-history.type';

/**
 * 이용내역 목록 조회
 * @endpoint GET /web/user-access-histories
 */
export function getUsageHistoriesApi(params?: UsageHistoryListParams) {
  return axiosInstance.get<PaginatedApiResponse<UsageHistoryItem>>('/web/user-access-histories', {
    params,
  });
}
